import axios from 'axios';

export function authHeader() {
  return { Authorization: `Bearer ${localStorage.getItem('token')}` };
}

const h = () => ({ headers: authHeader() });

export const hurricaneApi = {
  events: () => axios.get('/api/hurricane/events', h()),
  properties: () => axios.get('/api/hurricane/picker/properties', h()),
  locations: (propertyId) =>
    axios.get('/api/hurricane/picker/locations', { ...h(), params: { propertyId } }),
  residents: (locationId) =>
    axios.get('/api/hurricane/picker/residents', { ...h(), params: { locationId } }),
  context: (propertyId, locationId) =>
    axios.get('/api/hurricane/context', {
      ...h(),
      params: { propertyId, locationId: locationId || undefined },
    }),
  createReport: (body) => axios.post('/api/hurricane/reports', body, h()),
  getReport: (id) => axios.get(`/api/hurricane/reports/${id}`, h()),
  patchReport: (id, body) => axios.patch(`/api/hurricane/reports/${id}`, body, h()),
  submitReport: (id, body) => axios.post(`/api/hurricane/reports/${id}/submit`, body, h()),
  addDamageItem: (id, body) => axios.post(`/api/hurricane/reports/${id}/damage-items`, body, h()),
  deleteDamageItem: (id, itemId) =>
    axios.delete(`/api/hurricane/reports/${id}/damage-items/${itemId}`, h()),
  uploadReportPhoto: (id, file) => {
    const fd = new FormData();
    fd.append('image', file);
    return axios.post(`/api/hurricane/reports/${id}/photos`, fd, {
      headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' },
    });
  },
  uploadDamagePhoto: (id, itemId, file) => {
    const fd = new FormData();
    fd.append('image', file);
    return axios.post(`/api/hurricane/reports/${id}/damage-items/${itemId}/photos`, fd, {
      headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' },
    });
  },
  reports: (params) => axios.get('/api/hurricane/reports', { ...h(), params }),
  reportDetail: (id) => axios.get(`/api/hurricane/reports/${id}/view`, h()),
  adminEvents: () => axios.get('/api/hurricane/admin/events', h()),
  adminCreateEvent: (body) => axios.post('/api/hurricane/admin/events', body, h()),
  adminUpdateEvent: (id, body) => axios.put(`/api/hurricane/admin/events/${id}`, body, h()),
  adminDeleteEvent: (id) => axios.delete(`/api/hurricane/admin/events/${id}`, h()),
};
